import { render } from "./LockerInstructions_3.vue?vue&type=template&id=52c0a62f"
import script from "./LockerInstructions_3.vue?vue&type=script&lang=js"
export * from "./LockerInstructions_3.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mac/Projects/webshop/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__